/**
 * Quiz Detox Integrale — Scoring Algorithm (v2)
 *
 * SCORING LOGIC (v2, three-axes):
 * 1. Each answer adds points to foie / intestin / minceur axes
 * 2. Multi-select: all selected answers contribute (no capping)
 * 3. Total intensity = score_foie + score_intestin + score_minceur
 * 4. Cure assignment based on total intensity thresholds:
 *    - total <= lowMax    → C1 (Cure Express Détox)
 *    - total >= highMin   → C3 (Programme Transformation)
 *    - otherwise          → C2 (Cure Active Minceur)
 *
 * BACKWARD COMPAT: v1 answers use { c1, c2, c3 } score keys. If encountered,
 * we fall back to v1 sum/max logic so old archived configs keep working.
 */

(function() {
  'use strict';

  window.calculateDetoxCure = function(responses) {
    if (!responses || responses.length === 0) {
      console.error('No responses provided for scoring');
      return getDefaultResult();
    }

    var config = window.quizDetoxConfig || {};
    var mode = config.scoringMode || detectMode(responses);

    if (mode === 'three_axes') {
      return scoreThreeAxes(responses, config);
    }
    return scoreLegacyCures(responses, config);
  };

  function detectMode(responses) {
    // If any response has foie/intestin/minceur scores, use three_axes; otherwise legacy
    for (var i = 0; i < responses.length; i++) {
      var s = responses[i].scores;
      if (s && (s.foie !== undefined || s.intestin !== undefined || s.minceur !== undefined)) {
        return 'three_axes';
      }
    }
    return 'legacy';
  }

  function scoreThreeAxes(responses, config) {
    var scores = { foie: 0, intestin: 0, minceur: 0 };

    responses.forEach(function(response) {
      if (response.scores) {
        scores.foie     += response.scores.foie     || 0;
        scores.intestin += response.scores.intestin || 0;
        scores.minceur  += response.scores.minceur  || 0;
      }
    });

    var total = scores.foie + scores.intestin + scores.minceur;

    var thresholds = config.cureThresholds || { lowMax: 12, highMin: 22 };
    var cure;
    if (total <= thresholds.lowMax) {
      cure = 'c1';
    } else if (total >= thresholds.highMin) {
      cure = 'c3';
    } else {
      cure = 'c2';
    }

    // Dominant axis (useful for personalisation messaging downstream)
    var dominantAxis = 'intestin';
    if (scores.foie >= scores.intestin && scores.foie >= scores.minceur) dominantAxis = 'foie';
    else if (scores.minceur > scores.intestin) dominantAxis = 'minceur';

    return {
      cure: cure,
      scores: scores,
      total: total,
      dominantAxis: dominantAxis,
      cureName: (config.cureNames && config.cureNames[cure]) || cure,
      cureDuration: (config.cureDurations && config.cureDurations[cure]) || '',
      redirectUrl: config.redirectUrl || '/products/integrale-detox'
    };
  }

  // Legacy v1 scoring (kept so old archived configs still resolve correctly)
  function scoreLegacyCures(responses, config) {
    var scores = { c1: 0, c2: 0, c3: 0 };
    responses.forEach(function(r) {
      if (r.scores) {
        scores.c1 += r.scores.c1 || 0;
        scores.c2 += r.scores.c2 || 0;
        scores.c3 += r.scores.c3 || 0;
      }
    });
    var cure = 'c1';
    var max = scores.c1;
    if (scores.c2 >= max) { cure = 'c2'; max = scores.c2; }
    if (scores.c3 >= max) { cure = 'c3'; max = scores.c3; }
    return {
      cure: cure,
      scores: scores,
      maxScore: max,
      cureName: (config.cureNames && config.cureNames[cure]) || cure,
      cureDuration: (config.cureDurations && config.cureDurations[cure]) || '',
      redirectUrl: (config && config.redirectUrl) || '/products/integrale-detox'
    };
  }

  function getDefaultResult() {
    var config = window.quizDetoxConfig || {};
    return {
      cure: 'c2',
      scores: { foie: 0, intestin: 0, minceur: 0 },
      total: 0,
      dominantAxis: 'intestin',
      cureName: (config.cureNames && config.cureNames.c2) || 'Cure Active Minceur',
      cureDuration: (config.cureDurations && config.cureDurations.c2) || '60 jours',
      redirectUrl: (config && config.redirectUrl) || '/products/integrale-detox'
    };
  }

})();
